import { useEffect, useRef, useState } from "react";

/**
 * Returns a `[ref, inView]` pair that flips to `true` the first time the
 * element scrolls into view, then disconnects. For triggering imperative
 * on-enter animations (counters, bar/geo fills).
 */
export function useInViewOnce<T extends HTMLElement = HTMLDivElement>(
  threshold = 0.3,
) {
  const ref = useRef<T>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold]);

  return [ref, inView] as const;
}
